import { render, staticRenderFns } from "./four_terminal.vue?vue&type=template&id=0f258fc6&scoped=true"
import script from "./four_terminal.vue?vue&type=script&lang=js"
export * from "./four_terminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f258fc6",
  null
  
)

export default component.exports